import { MobileStepper, Stack, Step, StepLabel, Stepper } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import {
	BusinessDataContext,
	BusinessDataContextValues,
	MultistepContext,
	MultistepContextValues,
} from "../../types/context";
import "./Stepper.css";
import { useWindowResize } from "../../hooks/useWindowResize";
import { useIntl } from "react-intl";

//This component is a stepper, it shows the total number of steps and their names
export const HeaderStepper = () => {
	const { activeStep } = useContext(MultistepContext) as MultistepContextValues;

	const { selectedFlow } = useContext(
		BusinessDataContext
	) as BusinessDataContextValues;

	const { formatMessage } = useIntl();

	//We get the steps from the selected flow, but only the ones that are bigger than 0 (Home step).
	const [steps, setSteps] = useState(
		selectedFlow!.steps.filter((step) => step.number > 0)
	);
	useEffect(
		() => setSteps(selectedFlow!.steps.filter((step) => step.number > 0)),
		[selectedFlow]
	);

	const { isXSmall } = useWindowResize();

	//The visual component has a numeric steper, and a mobile stepper showing the progress
	return (
		<Stack id="headerStepperContainer" width="100%">
			<Stepper
				activeStep={activeStep - 1}
				connector={null}
				sx={{ maxWidth: "100%", overflowX: "auto" }}
			>
				{steps.map((step, index) => {
					return (
						<Step key={index}>
							<StepLabel>
								{(!isXSmall || activeStep === index + 1) &&
									formatMessage({
										id: `steps.${step.component}`,
										defaultMessage: "Paso desconocido",
									})}
							</StepLabel>
						</Step>
					);
				})}
			</Stepper>
			<MobileStepper
				sx={{ width: "100%" }}
				variant="progress"
				steps={steps.length + 2}
				position="static"
				activeStep={activeStep}
				nextButton={null}
				backButton={null}
			/>
		</Stack>
	);
};
